// src/Pages/Photography/Portraits.jsx
import * as React from "react";
import { ThemeProvider, createTheme, Typography, Box, Grid, Button, Modal } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import pic1 from "./photography/portraits/leonidpesenti-1.jpg";
import pic2 from "./photography/portraits/leonidpesenti-15.jpg";
import pic3 from "./photography/portraits/leonidpesenti-17.jpg";
import pic4 from "./photography/portraits/leonidpesenti-18.jpg";
import pic5 from "./photography/portraits/leonidpesenti-20.jpg";
import pic6 from "./photography/portraits/leonidpesenti-21.jpg";
import pic7 from "./photography/portraits/leonidpesenti-22.jpg";
import pic8 from "./photography/portraits/leonidpesenti-54.jpg";
import pic9 from "./photography/portraits/leonidpesenti-55.jpg";
import pic10 from "./photography/portraits/leonidpesenti-56.jpg";
import pic11 from "./photography/portraits/leonidpesenti-57.jpg";
import pic12 from "./photography/portraits/leonidpesenti-58.jpg";
import pic13 from "./photography/portraits/leonidpesenti-59.jpg";
import pic14 from "./photography/portraits/leonidpesenti-60.jpg";
import pic15 from "./photography/portraits/leonidpesenti-61.jpg";
import pic16 from "./photography/portraits/leonidpesenti-62.jpg";
import pic17 from "./photography/portraits/leonidpesenti-63.jpg";
import pic18 from "./photography/portraits/leonidpesenti-64.jpg";
import pic19 from "./photography/portraits/leonidpesenti-76.jpg";
import pic20 from "./photography/portraits/leonidpesenti-77.jpg";
import pic21 from "./photography/portraits/leonidpesenti-78.jpg";

import Footer from "../Footer";

export default function Portraits() {
  const base = createTheme();

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica",
      h1: { fontSize: "3rem", fontWeight: 200 },
      body1: {
        fontSize: "1.25rem",
        fontWeight: 200,
        lineHeight: 1.5,
        [base.breakpoints.down("sm")]: { fontSize: "1.25rem", fontWeight: 300 },
      },
    },
  });

  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const tablet = useMediaQuery("(min-width:768px) and (max-width:1000px)");
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const images = [
    pic1, pic2, pic3, pic4, pic5, pic11, pic18, pic20, pic9, pic10,
    pic6, pic12, pic13, pic14, pic15, pic16, pic17, pic7, pic21, pic8, pic19,
  ];

  const [open, setOpen] = React.useState(false);
  const [modalSrc, setModalSrc] = React.useState(null);

  const handleOpen = (src) => { setModalSrc(src); setOpen(true); };
  const handleClose = () => setOpen(false);

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        minHeight="100vh"
        marginTop="5vh"
        maxWidth="100vw"
        pb="10vh"
      >
        {/* Title */}
        <Typography variant="h1" sx={{ mb: "5vh", textAlign: "center" }}>
          // portraits
        </Typography>

        {/* Grid */}
        <Grid
          container
          spacing={2}
          justifyContent="flex-start" // rows align left
          alignItems="flex-start"
          sx={{ width: "80vw", maxWidth: 1200, pt: { xs: "1vh", sm: "2vh" } }}
        >
          {images.map((src, i) => {
            if (tablet) {
              return (
                <Grid key={i} item xs={6}>
                  <img src={src} alt={`Portrait ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                </Grid>
              );
            } else if (sm) {
              return (
                <Grid key={i} item xs={12}>
                  <img src={src} alt={`Portrait ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                </Grid>
              );
            } else {
              return (
                <Grid key={i} item xs={3}>
                  {isDesktop ? (
                    <Button onClick={() => handleOpen(src)} sx={{ p: 0, minWidth: 0, lineHeight: 0, cursor: "zoom-in" }}>
                      <img src={src} alt={`Portrait ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                    </Button>
                  ) : (
                    <img src={src} alt={`Portrait ${i + 1}`} style={{ width: "100%", height: "auto" }} />
                  )}
                </Grid>
              );
            }
          })}
        </Grid>
      </Box>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%", left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 0,
            outline: "none",
            maxWidth: "90vw",
            maxHeight: "80vh",
            display: "flex",
          }}
        >
          {modalSrc && (
            <img
              src={modalSrc}
              alt="Preview"
              style={{ maxWidth: "90vw", maxHeight: "80vh", width: "auto", height: "auto" }}
            />
          )}
        </Box>
      </Modal>

      <Footer fixed />
    </ThemeProvider>
  );
}
